module.exports = __webpack_public_path__ + "static/media/IMG_5854.109147dc.JPG";